import { Redirect } from "react-router-dom";
import AppHeaderLink, {
  AppHeaderLinkType,
} from "../../shared/src/components/AppHeader/AppHeaderLink";
import AppRouteProps from "../../shared/src/models/AppRouteProps";
import QTM from "../pages/QTM";
import QTMPath from "./QTMPath";

export const QTMAppHeaderLinks: AppHeaderLink[] = [
  {
    ...QTMPath.DSci,
    type: AppHeaderLinkType.LINK,
  },
];

export const QTMAppRoutes: AppRouteProps[] = [
  {
    ...QTMPath.QTM,
    exact: false,
    render: () => <Redirect to="/forms/dsci-student-onboarding" />,
  },
  {
    id: "dsci-student-onboarding",
    label: "DSCI Student Onboarding",
    path: "/forms/dsci-student-onboarding",
    exact: false,
    render: () => <QTM />,
  },
];

export function getQTMAppHeaderLinks(isStudent: boolean): AppHeaderLink[] {
  const newLinks = [];
  if (isStudent) {
    newLinks.push(...QTMAppHeaderLinks);
  }
  return newLinks;
}
